import { Stack } from 'expo-router';

import PlatformContainer from '@/components/web/PlatformContainer';

export default function StackLayout() {
  return (
    <PlatformContainer contentCustomClassnames="flex">
      <Stack>
        <Stack.Screen
          name="individual"
          options={{
            headerShown: false
          }}
        />
        <Stack.Screen
          name="nonProfit"
          options={{
            headerShown: false
          }}
        />
        <Stack.Screen
          name="notifications"
          options={{
            headerShown: false
          }}
        />
        <Stack.Screen
          name="location"
          options={{
            headerShown: false
          }}
        />
      </Stack>
    </PlatformContainer>
  );
}
